var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 16,
    stroke: "#E6E6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H23V16H1",
    fill: "#EE1C25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66657 2.5L5.95973 6.57025L2.57422 4.05475H6.75891L3.37341 6.57025L4.66657 2.5Z",
    fill: "#FFFF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6184 1.80988L8.49597 3.23095L7.77827 2.00769L9.06194 2.56593L7.7026 2.88594L8.6184 1.80988Z",
    fill: "#FFFF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3294 3.4778L9.67733 4.73891L9.48004 3.32667L10.4513 4.35063L9.07706 4.10606L10.3294 3.4778Z",
    fill: "#FFFF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4892 5.99329L9.39083 6.87267L9.77399 5.50096L10.2523 6.84106L9.09519 6.04443L10.4892 5.99329Z",
    fill: "#FFFF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5901 7.04854L8.52538 8.47358L7.75871 7.2818L9.06391 7.78513L7.71871 8.1625L8.5901 7.04854Z",
    fill: "#FFFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChine);
export default __webpack_public_path__ + "static/media/chine.938196d872252d5c0926ff31951e2656.svg";
export { ForwardRef as ReactComponent };